import class7 from "../../images/class7.png";
import class8_10 from "../../images/class8-10.png";
import class11_12 from "../../images/class11-12.png";
import professional from "../../images/professional.png";

const Tests = () => {
  const testData = [
    {
      id: 1,
      title: "Class up to 7th",
      // description: "(Class up to 7th to 12th)",
      image: class7,
      link: "https://gr8appers.drawmycareer.com/student-dashboard/suitability-registration/login/NDAyMA==/as11",
      features: [
        "Recommended study stream selection",
        "Most suited career recommendations",
        "Skill gap analysis",
        "Personality analysis",
        "Interventions for recommended careers",
      ],
    },
    {
      id: 2,
      title: "Class 8th to 10th",
      // description: "(Class up to 8th, 9th and 10th)",
      image: class8_10,
      link: "https://gr8appers.drawmycareer.com/student-dashboard/suitability-registration/login/NDAyMA==/as12",
      features: [
        "Recommended study stream selection",
        "Most suited career recommendations",
        "Skill gap analysis",
        "Personality analysis",
        "Interventions for recommended careers",
      ],
    },
    {
      id: 3,
      title: "Class 11th & 12th",
      // description: "(Working Professionals)",
      image: class11_12,
      link: "https://gr8appers.drawmycareer.com/student-dashboard/suitability-registration/login/NDAyMA==/as13",
      features: [
        "Recommended study stream selection",
        "Most suited career recommendations",
        "Skill gap analysis",
        "Personality analysis",
        "Interventions for recommended careers",
      ],
    },
    {
      id: 4,
      title: "Graduates & Professionals",
      // description: "(Working Professionals)",
      image: professional,
      link: "https://gr8appers.drawmycareer.com/student-dashboard/suitability-registration/login/NDAyMA==/as14-as204",
      features: [
        "Most suited career recommendations",
        "Skill gap analysis",
        "Personality analysis",
        "Interventions for recommended careers",
      ],
    },
  ];
  return (
    <div id="tests" >
      <div className="container flex flex-col align-center gap-16">
        <h3>Explore <b>Test</b></h3>
        <p className="lgText">
          Career Aptitude Test for students from 10th to 12th, graduates &
          professionals
        </p>
        <div className="cardList">
          {testData.map((test) => (
            <a href={test.link} target="_blank" rel="noopener noreferrer" className="card" key={test.id}>
              <div className="top">
                <img src={test.image} alt={test.title} />
                <div className="overlay">
                  <h4>{test.title}</h4>
                  <p>{test.description}</p>
                </div>
              </div>
              <ul className="list">
                {test.features.map((feature, index) => (
                  <li key={index}>{feature}</li>
                ))}
              </ul>
              <div className="actions">
                <span className="button">Get Started</span>
              </div>
            </a>
          ))}
        </div>
      </div>
    </div>
  );
};

export default Tests;
